import React from 'react';
import { Outlet } from 'react-router-dom';

const ADMIN_GRADIENT = 'linear-gradient(180deg, #0f1419 0%, #1a1f2e 50%, #0d1117 100%)';

const adminRootStyle = {
  minHeight: '100vh',
  width: '100%',
  background: ADMIN_GRADIENT,
};

const AdminLayout = () => (
  <div style={adminRootStyle} className="app-container app-container--admin">
    <main className="pageContent pageContent--admin">
      <Outlet />
    </main>
  </div>
);

export default AdminLayout;
